var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZmgFasteners(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 285.7 137.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        stroke: #305493;\n        stroke-width: 8px;\n      }\n\n      .st0, .st1, .st2 {\n        fill: none;\n        stroke-miterlimit: 10;\n      }\n\n      .st3 {\n        fill: #f3f3f5;\n      }\n\n      .st4 {\n        fill: #272e3d;\n      }\n\n      .st1 {\n        stroke: #6f9ad1;\n        stroke-width: 5px;\n      }\n\n      .st2 {\n        stroke: #272e3d;\n        stroke-width: .8px;\n      }\n\n      .st5 {\n        display: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND",
    className: "st5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    x: -171.2,
    y: -106.1,
    width: 750,
    height: 500
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 137.6,
    cy: 68.9,
    r: 68.6,
    transform: "translate(-8.5 117.5) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.6,68.9c0-33.7,27.3-61,61-61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M193.8,49.1c10.8,30.6-5.2,64.1-35.8,75"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M65.4,133.8c6.6,8,5.5,19.8-2.4,26.4s-19.8,5.5-26.4-2.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M62.5,136.2c5.3,6.3,4.4,15.8-1.9,21.1-6.3,5.3-15.8,4.4-21.1-1.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M57.4,140.4c2.9,3.5,2.5,8.8-1.1,11.8-3.5,2.9-8.8,2.5-11.8-1.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M276,80.1h-12.3c-.7,0-1.3-.2-1.7-.6-.4-.4-.6-.9-.6-1.5v-6.1h24.2c0,4.9-9.6,8.1-9.6,8.1ZM285.7,89.5v12.7c-4,2.9-8.2,5-12.7,6.4-4.5,1.4-9.4,2.1-14.8,2.1s-12.1-1-17.2-2.9c-5.1-2-9.4-4.7-13.1-8.2-3.6-3.5-6.4-7.8-8.3-12.7-1.9-5-2.9-10.4-2.9-16.3s.9-11.5,2.8-16.4c1.9-4.9,4.6-9.2,8.1-12.7,3.5-3.5,7.7-6.3,12.7-8.2,5-1.9,10.6-2.9,16.7-2.9s6,.2,8.7.7c2.7.5,5.2,1.1,7.4,2,2.3.9,4.4,1.9,6.3,3.1,1.9,1.2,3.8,2.6,5.4,4.2l-3,4.8c-.5.7-1.1,1.2-1.8,1.4-.8.2-1.6,0-2.5-.5-.9-.5-1.9-1.1-3-1.9-1.1-.7-2.5-1.4-4.2-2.1-1.6-.7-3.6-1.3-5.8-1.7-2.2-.5-4.8-.7-7.9-.7-4.4,0-8.5.7-12,2.2-3.6,1.4-6.7,3.5-9.2,6.2-2.5,2.7-4.5,6-5.8,9.8-1.4,3.8-2,8.1-2,12.9s.7,9.4,2.1,13.3c1.4,3.9,3.4,7.2,6,9.9,2.6,2.7,5.8,4.8,9.5,6.2,3.7,1.4,7.9,2.1,12.6,2.1s6.9-.4,9.8-1.2c2.8-.8,5.6-2,8.3-3.4v-7.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M107,41.9c.2,1.9.3,3.7.3,5.4v57.9h-9.3V26.4c5.8,0,9,15.5,9,15.5ZM128.5,61.2s9.1,17.2,9.5,18.2c.4,1,.8,1.9,1.2,2.9.4-1,.8-2,1.2-2.9.4-1,.8-1.9,1.3-2.8l26.7-48.4c.4-.8.9-1.4,1.5-1.5.5-.2,1.3-.3,2.2-.3h7.9v78.7h-9.3v-57.9c0-.8,0-1.6,0-2.5,0-.9.1-1.8.2-2.7l-27,49.2c-.8,1.6-2.1,2.5-3.8,2.5h-1.5c-1.7,0-3-.8-3.8-2.5l-12.1-23.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M45.9,51.8l-31.9,44.8h45v8.7H0v-4.2c0-.6,0-1.1.3-1.6.2-.5.5-1,.7-1.5l32.8-46.1M45.8,35.2H2.1v-8.7h57.6c0,5.6-14,8.7-14,8.7Z"
  }), /*#__PURE__*/React.createElement("image", {
    width: 863,
    height: 499,
    transform: "translate(-43.2 -1.2) scale(.4)",
    xlinkHref: "ZMGLogo-1.png"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZmgFasteners);
export default __webpack_public_path__ + "static/media/zmg-fasteners.8a8c33f109781407df396c16b1f9b57b.svg";
export { ForwardRef as ReactComponent };